import { useMask } from '@react-input/mask';
import { Input, InputProps } from 'antd';
import { forwardRef } from 'react';

export const PhoneInput = forwardRef(
  (props: Omit<InputProps, 'inputMode'>, ref) => {
    const inputRef = useMask({
      mask: '(___) ___-____',
      replacement: { _: /\d/ },
      showMask: true,
    });

    return (
      <Input
        placeholder="(999) 999-9999"
        {...props}
        inputMode="numeric"
        ref={(el) => {
          if (el) {
            if (typeof ref === 'function') {
              ref(el);
            } else if (ref) {
              ref.current = el;
            }
            inputRef.current = el?.nativeElement as any;
          }
        }}
      />
    );
  }
);
